import { Component, OnInit, ElementRef, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  standalone: false,
})
export class UiLoaderComponent implements OnInit {
  @Input() size: string;
  @Input() position: string;

  constructor(private el: ElementRef) {}

  ngOnInit() {
    const el = this.el.nativeElement;

    el.querySelector('svg').setAttribute('id', el.querySelector('svg').getAttribute('id') + +new Date());
  }
}
